import React from 'react';
import { Spin } from 'antd';
import * as S from './FullScreenLoader.styles';
import logoImg from '@app/assets/logo.jpg';

const FullScreenLoader: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Logo src={logoImg} alt="Logo" />
        <Spin size="default" />
      </S.Wrapper>
    </S.Container>
  );
};

export default FullScreenLoader;
